import { PATIENT_AVAILABILITY_INPUT_NAME } from '@components/app/ApplyPackagePage/consts'
import { useFormListener } from '@components/hooks/useFormListener/index.client'
import Button, { buttonClassNames } from '@components/primitives/Button'
import { Icon } from '@components/primitives/Icon'
import { classMerge } from '@components/utilities/classMerge'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight'
import { type ApplySuccessPageProps } from 'app/p/apply-success/[token]/[step]/page'
import { useEffect, useState } from 'react'

export const AvailabilityButtonGroup = (_props: ApplySuccessPageProps) => {
  const { formRef } = useFormListener('apply-success-form')

  const [selectedSlotCount, setSelectedSlotCount] = useState(0)
  useEffect(() => {
    if (formRef) {
      const updateSelectedSlotCount = () => {
        const inputs = formRef.querySelectorAll(
          `input[name="${PATIENT_AVAILABILITY_INPUT_NAME}"]`,
        )
        setSelectedSlotCount(inputs.length)
      }
      // Initial count
      updateSelectedSlotCount()
      // Listen for change events on the form
      formRef.addEventListener('input', updateSelectedSlotCount)
      // Cleanup listener on unmount
      return () => {
        formRef.removeEventListener('input', updateSelectedSlotCount)
      }
    }
  }, [formRef])

  return (
    <div className='z-10 mx-8 flex w-full flex-row justify-end gap-2'>
      <Button
        className={classMerge(
          buttonClassNames.legacy.fill.primary,
          'w-full rounded-full md:w-1/3',
        )}
        disabled={selectedSlotCount < 5}
        type='submit'
      >
        {selectedSlotCount < 5
          ? `Select ${5 - selectedSlotCount} more slots to advance`
          : 'Submit your availability'}
        <Icon className='ml-2' icon={faArrowRight} />
      </Button>
    </div>
  )
}
